export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Site"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID da loja"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configurações da loja"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Link de pagamento"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ativo"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inativo"])}
}